// extracted by mini-css-extract-plugin
export default {"Title":"Title_Title__GhfC6","Title__centerText":"Title_Title__centerText__piaqG","spin":"Title_spin__o+RVz"};